import React from 'react'
import { STATUS_REQUEST } from '../Processes/data/ArrayObjectsStatusRequest'

const ProgressBarStatusRequest = ({ statusIdRequest, showTitle = false }) => {
  const getProcessAndStyle = () => {
    const getArrayObject = STATUS_REQUEST.find(
      (status) => status.id === statusIdRequest
    )

    return {
      progress: getArrayObject.progress,
      styleProgress: getArrayObject.key,
      color: getArrayObject.color,
      name: getArrayObject.name,
    }
  }

  const { progress, styleProgress, color, name } = getProcessAndStyle()
  return (
    <div className="d-flex align-items-center">
      {showTitle && (
        <div
          style={{
            fontSize: '1rem',
            // fontWeight: 'bold',
            marginRight: '5px',
            // color: '#c4c4c4',
          }}
        >
          <strong>Estatus:</strong>
        </div>
      )}
      <div className={`progress-bar-container`}>
        <div
          className={`progress-bar ${styleProgress}`}
          style={{
            width: `${progress}%`,
            backgroundColor: color,
          }}
        ></div>{' '}
        <div className="progress-bar-text-container ">
          <span className="progress-bar-text">{name}</span>
        </div>
      </div>
    </div>
  )
}

export default ProgressBarStatusRequest
